import { LoginOutlined, LockOutlined, UserAddOutlined, CloseOutlined } from "@ant-design/icons";
import { Button, Modal, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import paths from "routes/paths";
import { OLIVEEB_COLORS } from "workspaces/colors";

const { Text } = Typography;

const styles = `
  .olreadia-signin-modal .ant-modal-content {
    border-radius: 18px;
    border: 1px solid ${OLIVEEB_COLORS.oliveebGreen};
    overflow: hidden;
    padding: 0;
    box-shadow: 0 18px 42px rgba(39,174,48,0.22);
  }
  .olreadia-signin-modal__body {
    position: relative;
    padding: 22px 18px 18px;
    background: #FFFFFF;
  }
  .olreadia-signin-modal__shine {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 7px;
    background: ${OLIVEEB_COLORS.oliveebBlue};
    border-bottom: 2px solid ${OLIVEEB_COLORS.oliveebGreen};
  }
  .olreadia-signin-modal__red {
    position: absolute;
    top: 0;
    right: 0;
    width: 62px;
    height: 7px;
    background: ${OLIVEEB_COLORS.oliveebRed};
  }
  .olreadia-signin-modal__close {
    position: absolute;
    top: 12px;
    right: 12px;
    width: 30px;
    height: 30px;
    border-radius: 999px;
    border: 1px solid #E5E7EB;
    background: ${OLIVEEB_COLORS.greenSoft2 || OLIVEEB_COLORS.oliveebGreenSoft};
    color: ${OLIVEEB_COLORS.textMuted};
  }
  .olreadia-signin-modal__icon {
    position: relative;
    width: 52px;
    height: 52px;
    border-radius: 17px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 12px;
    color: #FFFFFF;
    background: ${OLIVEEB_COLORS.oliveebGreen};
    border: 1px solid ${OLIVEEB_COLORS.oliveebYellow};
    font-size: 22px;
  }
  .olreadia-signin-modal__icon::after {
    content: "";
    position: absolute;
    right: -3px;
    bottom: -3px;
    width: 15px;
    height: 15px;
    border-radius: 999px;
    background: ${OLIVEEB_COLORS.oliveebRed};
    border: 2px solid #FFFFFF;
  }
  .olreadia-signin-modal__title {
    display: block;
    padding-right: 34px;
    color: ${OLIVEEB_COLORS.oliveebDarkGreen};
    font-size: 20px;
    line-height: 25px;
    font-weight: 900;
  }
  .olreadia-signin-modal__message {
    display: block;
    margin-top: 6px;
    color: ${OLIVEEB_COLORS.textMuted};
    font-size: 13px;
    line-height: 19px;
    font-weight: 700;
  }
  .olreadia-signin-modal__actions {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    margin-top: 16px;
  }
  .olreadia-signin-modal__actions .ant-btn,
  .olreadia-signin-modal__create.ant-btn {
    min-height: 42px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 900;
  }
  .olreadia-signin-modal__later.ant-btn {
    border-color: #F4B4B4;
    background: ${OLIVEEB_COLORS.redSoft};
    color: ${OLIVEEB_COLORS.oliveebRed};
  }
  .olreadia-signin-modal__login.ant-btn {
    background: ${OLIVEEB_COLORS.oliveebGreen};
    border-color: ${OLIVEEB_COLORS.oliveebGreen};
  }
  .olreadia-signin-modal__create.ant-btn {
    width: 100%;
    margin-top: 10px;
    border-color: #BBDDF8;
    background: ${OLIVEEB_COLORS.oliveebBlueSoft};
    color: ${OLIVEEB_COLORS.oliveebBlue};
  }
`;

export default function SignInRequiredModal({
  open,
  title = "Login required",
  message = "Please log in or create an account to continue.",
  onClose,
}) {
  const navigate = useNavigate();

  const goToLogin = () => {
    onClose?.();
    navigate(paths.simpleLogin);
  };

  const goToSignup = () => {
    onClose?.();
    navigate(paths.getStarted);
  };

  return (
    <>
      <style>{styles}</style>
      <Modal
        centered
        open={open}
        footer={null}
        closable={false}
        width={396}
        onCancel={onClose}
        className="olreadia-signin-modal"
        destroyOnClose
      >
        <div className="olreadia-signin-modal__body">
          <span className="olreadia-signin-modal__shine" aria-hidden="true" />
          <span className="olreadia-signin-modal__red" aria-hidden="true" />
          <button type="button" className="olreadia-signin-modal__close" onClick={onClose} aria-label="Close">
            <CloseOutlined />
          </button>
          <span className="olreadia-signin-modal__icon">
            <LockOutlined />
          </span>
          <Text className="olreadia-signin-modal__title">{title}</Text>
          <Text className="olreadia-signin-modal__message">{message}</Text>
          <div className="olreadia-signin-modal__actions">
            <Button className="olreadia-signin-modal__later" onClick={onClose}>
              Not now
            </Button>
            <Button type="primary" className="olreadia-signin-modal__login" icon={<LoginOutlined />} onClick={goToLogin}>
              Log in
            </Button>
          </div>
          <Button className="olreadia-signin-modal__create" icon={<UserAddOutlined />} onClick={goToSignup}>
            Create account
          </Button>
        </div>
      </Modal>
    </>
  );
}
